import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import * as dayjs from 'dayjs';
import { find, cloneDeep } from 'lodash';
import Enrollment from 'src/app/models/enrollment';
import Plan from 'src/app/models/plan';
@Component({
  selector: 'plan-change-banner',
  templateUrl: 'planChangeBanner.component.html',
  styleUrls: [],
  providers: []
})

export class PlanChangeBannerComponent implements OnInit, OnChanges {

@Input() enrollments: Enrollment[] = [];
@Input() isDashboard?: boolean = false; // Is this banner on the dashboard, or some other location (ex: Coverage Page)
@Input() agency: string;
@Input() selectedPlanIds: string[] = [];
@Input() availablePlans: Plan[] = [];
@Input() isSPForm: boolean = false;
startDate : string = "7/25/25";
endDate : string = "11/24/25";
displayBanner : boolean;
isEnrolledPlanGoingAway : boolean = false;
plansDissapearing = ['U1', 'V1', 'U2', 'V2'];
text : string;
title : string;
textInnerHTML : string;

  // Currently for UMP plus banner. Could be modified for future plans that are dissapearing 
  // Display when user has active plus plan (V1,V2,U2,V2) 
  ngOnInit(): void {
    this.setVariables();
  }

  setVariables() {
    this.isEnrolledPlanGoingAway = this.isEnrolledDissapearingPlan();
    //for the dashboard banner, it depends on if current date is within specific dates and they are enrolled in the plan
    //for the wizard banner, it only displays if the plan is selected.  The plan would no longer be in the list to be selected at some point, so would not dependent on current dates.
    this.displayBanner = this.isDashboard ? dayjs().isBetween(this.startDate, this.endDate, 'day', '[]') && this.isEnrolledPlanGoingAway : this.isEnrolledPlanGoingAway; 
    this.setLanguage();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.setVariables();
  }

  setLanguage() {
    // This language is valid until the end of OE 2025
    if (this.isDashboard) {
        this.title = 'UMP Plus closing December 31, 2025';
        this.textInnerHTML =`UMP Plus–Puget Sound High Value Network and UMP Plus–UW Medicine Accountable Care Network plans will end on December 31, 2025. You can stay enrolled in UMP Plus for 2025, but you must select a different medical plan during open enrollment, October 27 through November 24, 2025. 
          If you do not, you (and any dependents you cover) will be automatically enrolled in UMP Classic (PEBB) and UMP Achieve 2 (SEBB) effective January 1, 2026.  
          <a href="https://www.hca.wa.gov/about-hca/news/announcements/ump-plus-plans-closing-december-31" target="_blank">Learn more.</a>`;
    } else {
        this.title = 'UMP Plus closing December 31, 2025';
        this.textInnerHTML = `UMP Plus plans will end on December 31, 2025. You can choose this plan for the rest of 2025, <b>but you must choose a different plan for 2026</b>. 
        If you do not select a new plan for 2026 enrollment, you and your covered dependents will be automatically enrolled in ${this.agency === 'PEBB' ? 'UMP Classic' : 'UMP Achieve 2'} effective January 1, 2026.`;
    }
  }

  isEnrolledDissapearingPlan() : boolean {
      if (!this.selectedPlanIds || this.selectedPlanIds.length == 0) {
        return this.enrollments?.some(enrollment => this.plansDissapearing.includes(enrollment.plan.planCode) && (enrollment.effectiveEndDate === null 
          || enrollment.effectiveEndDate.getFullYear() > dayjs().year()));
      }
      else {
        return this.availablePlans?.some((ap:Plan)=> this.selectedPlanIds.some((sp)=> sp == ap.planId) && this.plansDissapearing.includes(ap.planCode));
      }
  }
}
